import {Card, CardTitle, Col, Container, Row} from "react-materialize";
import React from "react";
import { Tooltip } from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    DueDateLegend,
} from "./legends";
import {axiosClient} from "../api/httpClient";
import {convertServerToLocalTime, getIconComponent, getUserShortName, isAdmin, isCustomer, isTerminal, isTerminalYtCard, parseSqlDateTime} from "../api/Util";
import {CANCELED, DONE, ON_HOLD, VIDEO_REQUEST, YT_HELPER_IN_DONE, YT_HELPER_IN_PROGRESS, YT_HELPER_SECTION} from "../api/Constants";
import Timer from "react-compound-timer";
import {connect, useDispatch, useSelector} from "react-redux";
import moment from 'moment';

import {RiStackFill} from 'react-icons/ri';
import { VscComment } from  'react-icons/vsc';
import { AiOutlineTag } from  'react-icons/ai';
import { AiOutlinePlus } from  'react-icons/ai';
import { BiHourglass } from  'react-icons/bi';
import { BiTime } from  'react-icons/bi';
import { BsCheckAll, BsPerson } from  'react-icons/bs';
import { CommentOutlined } from "@ant-design/icons";
import { addEventsForCard } from "../services/cardsService";
import { AiOutlineCheck } from 'react-icons/ai';
import { SET_CURRENT_CARD_DATA, SET_YT_HELPER_ENABLE_MODAL } from "../actions/types";
import { getVideoTagType } from "../helpers/commonHelper";

function getDueDateRow(card, admin) {
    if (card.card_status === DONE || card.card_status === VIDEO_REQUEST || card.paused) {
        return "";
    }
    let now = new Date().getTime();
    let expiredTime = parseSqlDateTime(convertServerToLocalTime(card.due_date)).getTime() - now;
    let expired = (now - parseSqlDateTime(convertServerToLocalTime(card.due_date)).getTime()) > 0;

    return [
        <Row className="request-card-line" key="timer-row">
            {admin &&
            <Col s={6}>
                <BiHourglass/>&nbsp;
                {
                    expired ?
                        <span className="red-text">Overdue</span>:
                        <Timer initialTime={expiredTime} direction="backward">
                            <Timer.Days /> days&nbsp;
                            <Timer.Hours formatValue={val => `${`${val}`.padStart(2, "0")}:`}/>
                            <Timer.Minutes formatValue={val => `${val}`.padStart(2, "0")}/>
                        </Timer>
                }
            </Col>
            }
        </Row>,
        (card.due_date) &&
        <Row className="request-card-line" key="due-date-row">
            <Col m={12}>
                <AiOutlinePlus/>&nbsp;{moment(card.due_date).format('lll')}
            </Col>
        </Row>,
    ];
}

function getYTCardDueDateRow(card, customer) {
    if (card.ytHelper_card_status === YT_HELPER_IN_DONE || card.ytHelper_card_status == null ) {
        return "";
    }
    let now = new Date().getTime();
    let elapsedTime = now - parseSqlDateTime(convertServerToLocalTime(card.yt_assigned_time)).getTime();
    let expired = (now - parseSqlDateTime(convertServerToLocalTime(card.yt_due_date )).getTime()) > 0;

    return [
        (card.yt_assigned_time) &&
        <Row className="request-card-line" key="timer-row">
            {
                !customer ? <Col s={6}>
                    <BiTime/>&nbsp;
                    {
                        expired ?
                            <span className="red-text">Overdue</span>:
                            <Timer initialTime={elapsedTime}>
                                <Timer.Days /> days&nbsp;
                                <Timer.Hours formatValue={val => `${`${val}`.padStart(2, "0")}:`}/>
                                <Timer.Minutes formatValue={val => `${val}`.padStart(2, "0")}/>
                            </Timer>
                    }
                </Col> : null
            }
        </Row>,
        (card.yt_due_date) &&
        <Row className="request-card-line" key="due-date-row">
            <Col m={12}>
                <DueDateLegend/>&nbsp;{card.yt_due_date}
            </Col>
        </Row>,
    ];
}


export default connect(mapStateToProps)(({setCardActivityModal, setCardActivityData, card, viewCard, auth,section = "", setCardRepurposeModal, setCurrentCardId, currentCardRepurpose}) => {
    let ratingStar = "";
    let completeIcon = "";
    let pausedIcon = "";
    let revisionIcon = "";
    let revisionRepurposeIcon = "";
    let repurposeIcon ="";
    let repurposeConpleteIcon = "";
    let repurposeRatingStar = "";
    const customer = isCustomer(auth.loggedInUser);
    const admin = isAdmin(auth.loggedInUser);
    const dispatch = useDispatch();
    const { updatedYtHelperStatus } = useSelector((state) => state.kanbanFilterReducer);
    
    if(section !== YT_HELPER_SECTION)
    {
        if (card.card_status === DONE) {
            let rating = card.doneCardRating ?
                (<strong className="fa-layers-text">{card.doneCardRating}</strong>) :
                (getIconComponent("question-mark"));

            ratingStar = (
                (getIconComponent("rating", rating))
            )
    
            if (card.is_complete) {
                completeIcon = (
                    (getIconComponent("check-mark"))
                );
            }

            if (card.is_repurpose_complete) {
                let repurposeRating = card.repurposeCardRating ?
                    (<strong className="fa-layers-text">{card.repurposeCardRating}</strong>) :
                    (getIconComponent("question-mark"));

                repurposeRatingStar = (
                    (getIconComponent("rating", repurposeRating))
                )

                repurposeConpleteIcon = (
                    (getIconComponent("double-check-mark"))
                );
            }
        }
        if(card.repurpose_revisions > 0 && card.card_status === 'done' && (card.repurpose_status=== 'done' || card.repurpose_status === 'editing')){
            revisionRepurposeIcon = (<Tooltip title="Repurpose Revision" placement="top"><span>{getIconComponent("r-video-link")}</span></Tooltip>);
        }
        const hasRevisions = card.revision_nr > 0;
        const canRedo =
          !isTerminal(card.card_status) ||
          (card.card_status === 'done' && ['done', 'editing'].includes(card.repurpose_status));

        if (hasRevisions && canRedo) {
          revisionIcon = (<Tooltip title="Revision" placement="top"><span>{getIconComponent("r-video-link")}</span></Tooltip>);
        }
    
        if(card.paused && !isTerminal(card.card_status)) {
            pausedIcon = (getIconComponent("pause-circle"));
        }
        if(card.repurpose_aspect || card.repurpose_headline)
        {
            repurposeIcon = (getIconComponent("stack-fill"));
        }
    }
    else
    {
        if (card.ytHelper_card_status === YT_HELPER_IN_DONE) {
            let rating = card.doneCardRating ?
                (<strong className="fa-layers-text">{card.doneCardRating}</strong>) :
                ((getIconComponent("question-mark")));
            ratingStar = (
                (getIconComponent("rating", rating))
            )
    
            if (card.yt_is_complete) {
                completeIcon = (
                    (getIconComponent("check-mark"))  
                );
            }
        }
    
        if(card.yt_card_revision > 0 && !isTerminalYtCard(card.ytHelper_card_status)) {
            revisionIcon = (getIconComponent("r-video-link"))
        }
    
        // paused functionality is not there for yt helper card
        // if(card.paused && !isTerminalYtCard(card.ytHelper_card_status)) {
        //     pausedIcon = (<FontAwesomeIcon icon="pause-circle" color="blue" pull="right"/>)
        // }
    }

    return (
        <Card className="request-card" onClick={() => {
            addEventsForCard('card_open', card.card_id);
            viewCard(card.card_id);
            const cmtId = "comment-outlined-" + card.card_id;
            if ((card.unseenComments === 0) && (card?.qa_assigned_to ===  auth?.loggedInUser?.client_id)) {
                document.getElementById(cmtId).style.display = "none";
            }
        }}
              header={<CardTitle className="request-card-title" image="" onClick={() => viewCard(card.card_id)}>
                <span className="card-title-text">{card.card_title}</span>
                <div className="card-icon-container">
                  {ratingStar}
                  {completeIcon}
                  {repurposeRatingStar}
                  {repurposeConpleteIcon}
                  {revisionRepurposeIcon}
                  {revisionIcon}
                  {pausedIcon}
                  {repurposeIcon}
                  {card.unseenComments === 0 && getIconComponent("new-comment", null, `comment-outlined-${card.card_id}`)}
                </div>
              </CardTitle>}
        >
            <Container>
                <Row className="request-card-line">
                    <Col s={6} m={12} l={6}>
                       <BsPerson/>
                        &nbsp;<strong>{card.firstname || card.lastname ? `${card.firstname || ''} ${card.lastname || ''}` : 'N/A'}</strong>
                    </Col>
                    <Col s={6} m={12} l={6}>
                        <AiOutlinePlus/>&nbsp;{card.creation_time}
                    </Col>
                    <Col s={6} m={12} l={6}>
                       <BsPerson/>
                        &nbsp; <strong>{card.qa_firstname || card.qa_lastname ? `${getUserShortName(card.qa_firstname || '', card.qa_lastname || '')}` : 'N/A'}</strong>
                    </Col>
                </Row>
                {
                    !customer ?
                        <Row className="request-card-line">
                            <Col s={6} m={12} l={6}>
                            <AiOutlineTag/>&nbsp;<strong>{card.subscription_type}</strong>
                            </Col>
                        </Row> : null
                }
                {
                    card?.video_tag_type ?
                        <Row className="request-card-line">
                            <Col>
                            <AiOutlineTag/>&nbsp;<strong>{ getVideoTagType(card.video_tag_type)}</strong>
                            </Col>
                        </Row> : null
                }
                {
                    (card.yt_helper_id || updatedYtHelperStatus) ? (
                        <Row className="request-card-line">
                            <Col s={6} m={12} l={10}>
                                <AiOutlineTag />&nbsp;<strong>{"Yt Helper Status: " + (updatedYtHelperStatus ? "ASSIGNED CARD" : (card?.ytHelper_card_status ?
                                    (card?.ytHelper_card_status === YT_HELPER_IN_PROGRESS ? "Progress"
                                        : (card?.ytHelper_card_status === "inDone" && card?.yt_is_complete === 1
                                            ? "Completed" : "Review")) : "ASSIGNED CARD"))}</strong>
                            </Col>
                        </Row>) : (card?.has_youtube_helper === 1 && (customer || admin) && (
                            <Row className="request-card-line">
                                <Col s={6} m={12} l={10}>
                                    <AiOutlineTag />&nbsp;<strong>Yt Helper: <strong className="yt-helper-enable" onClick={async (event) => {
                                        event.stopPropagation();
                                        event.preventDefault();
                                        dispatch({ type: SET_YT_HELPER_ENABLE_MODAL, payload: true });
                                        dispatch({ type: SET_CURRENT_CARD_DATA, payload: card });
                                    }} >Enable Yt-Helper</strong></strong>
                                </Col>
                            </Row>
                        ))
                }
                { section === YT_HELPER_SECTION ? getYTCardDueDateRow(card, customer) : getDueDateRow(card, admin)}
                {
                    section === YT_HELPER_SECTION ? (card.yt_comments ?
                        <Row>
                            <Col m={3}>
                            <VscComment/>&nbsp;{card.yt_comments}
                            </Col>
                        </Row> : "") 
                    :
                    (card.comments ?
                        <Row>
                            <Col m={3}>
                            <VscComment/>&nbsp;{card.comments}
                            </Col>
                        </Row> : "")
                }
                    <Row className="card-activity-btn">
                {!customer ?
                        <Col s={6} m={12} l={6}>
                            <button className="activity-status-btn" onClick={async (event) => {
                                setCardActivityData([]); 
                                event.preventDefault(); // Prevent default link behavior
                                event.stopPropagation(); 
                                setCardActivityModal(true);
                                const data = await axiosClient.get('/api/card-activity/' + card.card_id);
                                setCardActivityData(data.data);
                            }}>
                                <strong>Activity Status</strong>
                            </button>
                        </Col>: null
                }
                  { !card.repurpose_aspect && currentCardRepurpose && (customer || admin) ?
                    <Col s={6} m={10} l={6}>
                        <button className="activity-status-btn"onClick={async (event) => {
                            event.stopPropagation();
                            event.preventDefault(); // Prevent default link behavior
                            setCardRepurposeModal(true);
                            setCurrentCardId(card.card_id)
                        }}>
                            <strong>{<AiOutlineCheck />}Repurpose</strong>
                        </button>
                    </Col>:null
                  }
                    </Row> 
            </Container>
        </Card>
    );
});

function mapStateToProps({auth}) {
    return {auth};
}
